import cntl from 'cntl';

interface SeparatorBarProps {
  thickness?: 'hairline' | 'medium' | 'thick';
  color?: string;
  className?: string;
}

const SeparatorBar = ({
  thickness = 'hairline',
  color = '#000000',
  className = '',
}: SeparatorBarProps) => {
  const heightMap = {
    hairline: 'h-[1px]',
    medium: 'h-[4px]',
    thick: 'h-[8px]',
  };

  return (
    <div
      className={`w-full ${heightMap[thickness]} ${className}`}
      style={{ backgroundColor: color }}
    />
  );
};

export default SeparatorBar;
